import React from 'react';
import PropTypes from 'prop-types';
import PhoneNumber from '../phoneNumber';

const ContactPanel = ({ children, phoneNumber, submitEnquiryParamsForm }) => {
  return (
    <div className="productheader__contact">
      <div className="ch-bg--grey-1 md:ch-display--flex md:ch-justify-content--between">
        <div className="md:ch-text--left md:ch-width--7 md:ch-pa--3">
          <p className="ch-text--bold ch-fs--3 ch-mb--0 ch-mt--2 md:ch-mt--0">
            Our contact centre is open
          </p>
          <span>
            Call us on{' '}
            <PhoneNumber
              additionalClasses="ch-text--bold ch-fs--2"
              number={phoneNumber}
              origin="Contact panel"
            />
            *
          </span>
        </div>
        <div className="ch-display--flex ch-justify-content--center ch-pa--1 md:ch-width--5 ch-flex-flow--column-nowrap">
          <button
            className="ch-btn ch-btn--secondary ch-ma--1"
            data-event-name="Product page: Enquire Now CTA"
            data-gtm-track="click_cta"
            data-gtm-track-label="Enquire now"
            data-insight-event="conversion"
            onClick={submitEnquiryParamsForm}
            type="button"
          >
            Enquire now
          </button>
        </div>
      </div>
      {children}
    </div>
  );
};

ContactPanel.displayName = 'ContactPanel';

ContactPanel.propTypes = {
  children: PropTypes.node,
  phoneNumber: PropTypes.string,
  submitEnquiryParamsForm: PropTypes.func,
};

export default ContactPanel;
